export default __webpack_public_path__ + "static/media/landing_screen.ea401976.png";